import React from 'react';
import { Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import NewButton from '../../common/components/NewButton';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye } from '@fortawesome/free-regular-svg-icons';

const List = ({ isReadonly, t, ...rest }) => {
	const columns = [
		{
			header: t('WeeklyInformation_Grade'),
			accessor: 'grade.name',
			sortable: true
		},
		{
			header: t('WeeklyInformation_WeekNumber'),
			accessor: 'weekNumber',
			sortable: true
		},
		{
			header: t('WeeklyInformation_IsOnline'),
			accessor: 'isOnline',
			sortable: true,
			cell: (isOnline) => (ui.formatBoolean(isOnline))
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id) => (<Link to={`/weeklyInformations/${id}`} className='btn btn-teal'><FontAwesomeIcon icon={isReadonly ? faEye : faEdit} /> {t(isReadonly ? 'Common_View' : 'Common_Edit')}</Link>)
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} listActions={!isReadonly && <NewButton newItemPath='/weeklyInformations/new' />} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);